export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YL5rilss6yLUrwA.d5a10154.woff2";